// Detect if we are running in a local mobile dev environment, e.g. iPhone
export const isMobileDev = window.location.hostname === "sen-air.local";

export const API_BASE = isMobileDev
  ? "http://sen-air.local:5679"
  : import.meta.env.KTT_API_URL_FULL || `${Bun.env.KTT_API_URL}:${Bun.env.KTT_API_PORT}`;
